export const en = {
    "k_b7b02562": "Data source middleware cannot be registered twice",
    "k_18885fa5": "Recent visit to",
    "k_38ec776f": "Target database",
    "k_3f77270b": "Please select a database",
    "k_ea08e9b": "Please select a database and enter appId or name to search",
    "k_b25b2229": "You do not have administrator privileges for this database. Please ask the administrator to authorize it.",
    "k_367bfd12": "Please enter the name of the database you want to access",
    "k_bedbbe5a": "Please enter database user name",
    "k_c36d1d98": "Please enter the password for the database",
    "k_c73bb71c": "Please enter the IP address of the database",
    "k_8d1f1aff": "Please enter the port number of the database",
    "k_9e60d1a4": "Please enter the database domain name or Polaris address",
    "k_4de55a69": "Database type",
    "k_fd52d17c": "Project ID",
    "k_835f8b45": "Please enter the project ID, which is used as a unique identification within the platform. Only letters, numbers and underscores can be used",
    "k_341510b3": "Please enter the project name. It is recommended to enter a readable Chinese name",
    "k_4f1ef1b": "Item description",
    "k_d53450f4": "Please enter the project description and suggest describing the data content, data source and purpose, etc.",
    "k_27ee35e1": "Corresponding to \"character_set_client\",\"character_set_connection\", \"character_set_results\" settings",
    "k_10115b2d": "The default value is utf8mb4",
    "k_a227d0d4": "Character sorting method",
    "k_62a0d37f": "The default value is `UTF8MB4_GENERAL_CI`. Note that all letters in the character set must be capitalized.",
    "k_a1fda65b": "Big numbers",
    "k_54f68f51": "If the type `BIGINT` is involved in the mount table, this attribute needs to be turned on",
    "k_be516831": "Database",
    "k_bf5c5e65": "Please enter the name of the target database",
    "k_de99cde5": "User name",
    "k_cd3796ba": "Database user name",
    "k_5602e656": "Database password",
    "k_193a3435": "Database IP",
    "k_a0ccb0fa": "Database port number",
    "k_ee0e963e": "Host of the database",
    "k_a5f6037b": "Connection mode",
    "k_416a7866": "Domain name or North Star",
    "k_158e50c3": "The database needs to authorize necessary data operation permissions. Please refer to the detailed document.",
    "k_745b7179": "Mount your own database »",
    "k_4dc9f724": "Test Connection",
    "k_17d96e39": "Test is successful",
    "k_81ac8f7b": "Test failed: {arg_0}",
    "k_46dcf93f": "New database",
    "k_e3b18149": "Create a database",
    "k_ebdfa66d": "Mount external database",
    "k_a5a9d846": "Project database:",
    "k_d9b21596": "Add database",
    "k_ddd1107d": "Failed to load project database:",
    "k_d30e55a9": "Failed to load project database {arg_0}",
    "k_3d8cd427": "Add database successfully",
    "k_95a00aa6": "You can be authorized to",
    "k_2cccbe11": "Database registered in"
};
